module.exports = __webpack_public_path__ + "media/src/images/abouts/icons/facebook-53f3f37aaadf99b23023e3e5f3ebcc7f.svg";